"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Check whether can move current snapshot with the given step
 * @param snapshots The snapshots data structure to check
 * @param step The step to check, can be positive, negative or 0
 * @returns True if can move current snapshot with the given step, otherwise false
 */
function canMoveCurrentSnapshot(snapshots, step) {
    var newIndex = snapshots.currentIndex + step;
    return newIndex >= 0 && newIndex < snapshots.snapshots.length;
}
exports.default = canMoveCurrentSnapshot;
//# sourceMappingURL=canMoveCurrentSnapshot.js.map